import { Component,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../../../services/cart.service';
import { Product } from '../../../models/product.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/app/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-copy-paste',
  templateUrl: './copy-paste.component.html',
  styleUrls: ['./copy-paste.component.less']
})
export class CopyPasteComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() canAdd: EventEmitter<boolean> = new EventEmitter<boolean>();
  textValue:string="";
  lineNumber: string = '1\n';//init lineNumber
  result: { isValid: boolean; data?: any[]; errors?: string[] } = { isValid: false, data: [], errors: [] };
  constructor(private commonService:CommonService,private router: Router,private cartService: CartService,private message: NzMessageService,private translate: TranslateService) { }


  ngOnInit(): void {
  }
  onTextValueChange(newValue: string): void {
      const canAdd =this.result.isValid || this.textValue.trim().length==0
      this.canAdd.emit(canAdd);
  }
  inputText: string = '';

  onInputChange(): void {
    this.updateLineNumber();
  }

  onInputScroll(): void {
    this.syncLineNumberScroll();
  }

  private updateLineNumber(): void {
    const lines = this.textValue.split('\n');
    this.lineNumber = '';
    for (let i = 1; i <= lines.length; i++) {
      this.lineNumber += i + '\n';
    }
  }

  private syncLineNumberScroll(): void {
    const inputElement = document.getElementById('input');
    const leftTxtElement = document.getElementById('line-number');
    if (inputElement && leftTxtElement) {
      leftTxtElement.scrollTop = inputElement.scrollTop;
    }
  }
  checkValue(): void{
    this.result ={ isValid: false, data: [], errors: [] };
    const lines = this.textValue.split('\n');
    for (const [index, line] of lines.entries()) {
      const values = line.trim().split(/[;\s]+/);
      if(!line.trim()){continue;}
      if (values.length === 1) {
        const materialNumber = line.trim();
        if (!materialNumber || materialNumber.length == 1) {
          this.result.isValid = false;
          this.result.errors?.push(`${index + 1}: Product with material number ${materialNumber} is not available.`);
        } else {
          this.result.data?.push({ materialNumber, quantity: 1, expectDate: this.commonService.formatDateString(new Date()) });
        }
      } else if (values.length === 2) {
        const materialNumber = values[0];
        const quantity = values[1];

        if (!materialNumber || materialNumber.length == 1) {
          this.result.isValid = false;
          this.translate.get('PRODUCT_NOT_AVAILABLE', { index: index + 1, materialNumber: materialNumber }).subscribe((translatedText: string) => {
            this.result.errors?.push(translatedText);
          });
          //this.result.errors?.push(`${index + 1}: Product with material number ${materialNumber} is not available.`);
        } else if (isNaN(+quantity)) {
          this.result.isValid = false;
          this.translate.get('QUANTITY_NOT_AVAILABLE', { index: index + 1, materialNumber: materialNumber }).subscribe((translatedText: string) => {
            this.result.errors?.push(translatedText);
          });
          //this.result.errors?.push(`${index + 1}: Quantity for product with material number ${materialNumber} is not a valid number.`);
        } else {
          this.result.data?.push({ materialNumber, quantity: +quantity, expectDate: this.commonService.formatDateString(new Date()) });
        }
      } else {
        this.result.isValid = false;
        this.translate.get('NOT_AVAILABLE', { index: index + 1}).subscribe((translatedText: string) => {
          this.result.errors?.push(translatedText);
        });
        //this.result.errors?.push(`${index + 1}: Input format is not correct.`);
      }

    }
    if(this.result?.errors?.length==0){
      this.result.isValid=true;
      this.addToCart();
    }
  }
  addToCart(): void {
    const products: Product[] = [];
    this.result?.data?.forEach((control: any) => {
      let productNumber = control.materialNumber;
      if(productNumber){
        const dateValue: Date | null = control.date || new Date();
        const formattedDate: string = dateValue
          ? this.commonService.formatDateString(dateValue)
          : '';
          if(localStorage.getItem('country')=='/iam'){
            productNumber = productNumber.trim().replace(/\s+/g, '').substring(0, 10).toUpperCase();
          }
        const product: Product = {
          inputMaterialNumber: productNumber,
          expectedDate: formattedDate,
          quantity: +control.quantity || 1,
        };

        products.push(product);
      }
    });
    if(products.length>500){
      this.message.create('warning',  this.translate.instant('ADD_MAX_NUM_TIPS'));
      return;
    }
    this.cartService.addToCart(products).then(()=>{
      const currentUrl = this.router.url;
      const country = localStorage.getItem("country"); 
      if (currentUrl !== `${country}/cart`) {
        this.router.navigateByUrl(`${country}/cart`);
      } 
      this.closeModal.emit();
    })
  }
}
